// pages - synthesis
import SynthesisREC1 from '../../../page/synthesis/synthesisREC1'
import SynthesisREC2 from '../../../page/synthesis/synthesisREC2'

// pages - synthesis review
import SynthesisReviewREC1 from '../../../page/synthesisReview/synthesisReviewREC1'
import SynthesisReviewREC2 from '../../../page/synthesisReview/synthesisReviewREC2'

// pages - additional document
import AdditionalDocumentREC1 from '../../../page/additionalDocument/additionalDocumentREC1'
import AdditionalDocumentREC2 from '../../../page/additionalDocument/additionalDocumentREC2'

// pages - verify document
import VerifyDocumentREC1 from '../../../page/verifyDocument/projectProgressReport/verifyDocumentREC1'
import VerifyDocumentREC2 from '../../../page/verifyDocument/projectProgressReport/verifyDocumentREC2'

// pages - define project
import DefineProjectREC1 from '../../../page/defineProject/defineProjectREC1'
import DefineProjectREC2 from '../../../page/defineProject/defineProjectREC2'

// pages - define submitted date
import DefineSubmittedDateREC1 from '../../../page/defineSubmittedDate/defineSubmittedDateREC1'
import DefineSubmittedDateREC2 from '../../../page/defineSubmittedDate/defineSubmittedDateREC2'

// pages - reviewer comment
import ReviewerCommentREC1 from '../../../page/reviewerComment/reviewerCommentREC1'
import ReviewerCommentREC2 from '../../../page/reviewerComment/reviewerCommentREC2'

// pages - generate certificate
import GenerateCertificateREC1 from '../../../page/generateCertificate/generateCertificateREC1'
import GenerateCertificateREC2 from '../../../page/generateCertificate/generateCertificateREC2'

// pages - sign
import SignREC1 from '../../../page/sign/signMemoMessage/signREC1'
import SignREC2 from '../../../page/sign/signMemoMessage/signREC2'

// pages - sign represent
import SignRepresentREC1 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC1'
import SignRepresentREC2 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC2'

// pages - memo message
import MemoMessageREC1 from '../../../page/memoMessage/projectProgressReport/memoMessageREC1'
import MemoMessageREC2 from '../../../page/memoMessage/projectProgressReport/memoMessageREC2'

// pages - other
import ResultOfConsiderPrevious from '../../../page/resultOfConsiderPrevious/resultOfConsiderPrevious'

// hooks / stores
import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useCheckPermission from '../../../../../../utilities/checkPermission'

// types / constants
import { OfficerType } from './officerType'
import * as Constants from '../../../../../../constants/constants'
import constSubmittedStep from '../../../../../../constants/submittedStep'
import submittedType from '../../../../../../constants/submittedType'

const OfficerView: React.FC<OfficerType> = (props) => {
    const { callbackSaveComplete } = props
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const checkPermission = useCheckPermission()

    const renderPage = () => {
        const tabID = appFolderAndTabStore?.tabSelected?.id
        const REC = manageProjectStore?.projectData?.irbType
        let isNotDisableTestResult = false
        switch (REC) {
            case 1:
                switch (tabID) {
                    case Constants.menuTab.tab1.id:
                        // tab1 <div> ตรวจสอบเอกสาร REC1</div>
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.specifyProjectType
                        }
                        return (
                            <VerifyDocumentREC1
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab2.id:
                        // code block
                        // return <div> กำหนดประเภทโครงการและกรรมการ REC1</div>
                        return (
                            (manageProjectStore?.projectData && (
                                <DefineProjectREC1
                                    projectData={manageProjectStore?.projectData}
                                    onSaveComplete={callbackSaveComplete}
                                />
                            )) || <></>
                        )
                    case Constants.menuTab.tab3.id:
                        // code block กำหนดชุดโครงการที่ต้องส่ง
                        return <AdditionalDocumentREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab4.id:
                        // code blockชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก
                        return <DefineSubmittedDateREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab5.id:
                        // code block บันทึกข้อคิดเห็นของกรรมการ
                        return (
                            <ReviewerCommentREC1
                                submitTypeID={submittedType.highRiskProjectProgressReport}
                                callbackSaveComplete={callbackSaveComplete}
                                isOneComment={true}
                            />
                        )

                    case Constants.menuTab.tab6.id:
                        // code block สังเคราะห์

                        return (
                            <SynthesisREC1
                                submitTypeID={submittedType.highRiskProjectProgressReport}
                                callbackSaveComplete={callbackSaveComplete}
                                isOneComment={true}
                            />
                        )
                    case Constants.menuTab.tab7.id:
                        // code block ออกผล
                        return <SynthesisReviewREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab8.id:
                        // code block ออกใบรับรอง
                        return <GenerateCertificateREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab9.id:
                        // code block ลงนาม
                        return <SignREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        // code block ลงนามแทน
                        return <SignRepresentREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab11.id:
                        // code block
                        return (
                            <MemoMessageREC1
                                projectData={manageProjectStore?.projectData}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )
                    case Constants.menuTab.tab26.id:
                        return (
                            <ResultOfConsiderPrevious
                                projectID={manageProjectStore?.projectData?.projectID ?? 0}
                                submittedID={
                                    manageProjectStore?.projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0
                                }
                            />
                        )
                    default:
                        return <div></div>
                }

            case 2:
                switch (tabID) {
                    case Constants.menuTab.tab1.id:
                        // tab1
                        // return <div> ตรวจสอบเอกสาร REC2</div>
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.specifyProjectType
                        }
                        return (
                            <VerifyDocumentREC2
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab2.id:
                        // code block
                        // return <div> กำหนดประเภทโครงการและกรรมการ REC2</div>
                        return (
                            (manageProjectStore?.projectData && (
                                <DefineProjectREC2
                                    projectData={manageProjectStore?.projectData}
                                    onSaveComplete={callbackSaveComplete}
                                />
                            )) || <></>
                        )
                    case Constants.menuTab.tab3.id:
                        /// code block กำหนดชุดโครงการที่ต้องส่ง
                        return <AdditionalDocumentREC2 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab4.id:
                        // code blockชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก
                        return <DefineSubmittedDateREC2 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab5.id:
                        // code block บันทึกข้อคิดเห็นของกรรมการ
                        return (
                            <ReviewerCommentREC2
                                submitTypeID={submittedType.highRiskProjectProgressReport}
                                callbackSaveComplete={callbackSaveComplete}
                                isOneComment={true}
                            />
                        )

                    case Constants.menuTab.tab6.id:
                        // code block
                        return (
                            <SynthesisREC2
                                submitTypeID={submittedType.highRiskProjectProgressReport}
                                callbackSaveComplete={callbackSaveComplete}
                                isOneComment={true}
                            />
                        )
                    case Constants.menuTab.tab7.id:
                        // code block
                        return <SynthesisReviewREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab8.id:
                        // code block
                        return <GenerateCertificateREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab9.id:
                        // code block
                        return <SignREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        // code block
                        return <SignRepresentREC2 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab11.id:
                        // code block
                        return (
                            <MemoMessageREC2
                                projectData={manageProjectStore?.projectData}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )
                    case Constants.menuTab.tab26.id:
                        return (
                            <ResultOfConsiderPrevious
                                projectID={manageProjectStore?.projectData?.projectID ?? 0}
                                submittedID={
                                    manageProjectStore?.projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0
                                }
                            />
                        )
                    default:
                        return <div></div>
                }

            default:
                return <div></div>
        }
    }

    return <> {renderPage()} </>
}

const Officer: React.FC<OfficerType> = (props) => {
    return <OfficerView {...props} />
}
export default Officer
